<template>
  <span :title="long">{{ regular }}</span>
</template>

<script>
import { Formatters } from '@/utils/formatters'

export default {
  data () {
    return {
      strings: {},
      data: {}
    }
  },
  props: {
    field: {
      type: String,
      required: true
    }
  },
  computed: {
    long () {
      return Formatters.DateTime.Long(this.data[this.field])
    },
    regular () {
      return Formatters.DateTime.Regular(this.data[this.field])
    }
  }
}
</script>

<style>
</style>
